module.exports = __webpack_public_path__ + "static/media/uc-corporate--light.07358760.svg";